import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import LinkPreviewCard from 'src/components/LinkPreviewCard/LinkPreviewCard';
import calcomBookingDashboardPreview from '../../assets/calcom-booking-dashboard-preview.jpg';
import './key-pickup-scheduling-callout.scss';

// Shown at the top of the key-pickup invite dialog. Key pickups predate any scheduling — they were
// a Juniper-only concept, and Cal.com booking is layered on top. Users don't realise the homeowner
// self-books (not them) and that the booking is then owned in Cal.com, so we spell out the handoff
// and where it continues rather than letting them assume Juniper fills the calendar itself.
const KeyPickupSchedulingCallout = () => {
  return (
    <div className="key-pickup-scheduling-callout">
      <Callout
        variant="info"
        title="How key-pickup scheduling works"
        subtitle={
          <>
            Key pickups are a Juniper feature — the scheduling on top is powered
            by Cal.com. When you send, Juniper emails the unit&apos;s primary
            homeowner a branded email with a &ldquo;Book your key pickup&rdquo;
            button. You don&apos;t pick the time — they do.
          </>
        }
      >
        <p className="key-pickup-scheduling-callout-detail">
          That button doesn&apos;t open Juniper — it takes the homeowner to
          Cal.com to book a slot against your connected Cal.com availability.
          Once they book, the appointment lands on your Cal.com calendar, and
          that&apos;s where it&apos;s rescheduled or cancelled. The calendar
          invite comes from Cal.com, not Juniper.
        </p>

        <LinkPreviewCard
          href="https://cal.com/blog/a-complete-walkthrough-of-cal-com-s-booking-dashboard-its-key-features"
          title="Where pickups are managed after booking"
          description="How homeowners book, and where to view, reschedule, or cancel pickups in Cal.com."
          siteName="Cal.com"
          image={calcomBookingDashboardPreview}
        />
      </Callout>
    </div>
  );
};

export default KeyPickupSchedulingCallout;